<div class="row mb-3">
  <div class="col-12">
    <h3 *ngIf="mode === 'NEW'">{{ "accounts.transfers.account-creation" | translate }}</h3>
    <h3 *ngIf="mode === 'EDIT'">{{ "accounts.transfers.account-update" | translate }}</h3>

    <section *ngIf="targetAccountType === eTargetAccountTypes.INTERNAL_CARD">
      <ng-container *ngTemplateOutlet="INTERNAL_CARD"></ng-container>
    </section>

    <!-- SECCIÓN PARA INTERNATIONAL CARD
    <section *ngIf="targetAccountType === eTargetAccountTypes.INTERNATIONAL">
      <ng-container *ngTemplateOutlet="INTERNATIONAL"></ng-container>
    </section>
    -->
  </div>
</div>

<ng-template #INTERNAL_CARD>
  <form #form="ngForm" (ngSubmit)="form.form.valid && onSubmitLocalAccount(form)">
    <div class="row">
      <div *ngIf="mode == 'NEW'" class="col-12 col-md-6">
        <label>{{ "accounts.transfers.card-number" | translate }}</label>
        <div class="input-group">
          <input (input)="onInputChange($event)" type="text" class="form-control" name="accountNumber" mask="0000 0000 0000 0000" [(ngModel)]="targetAccount.accountNumber" #accountNumber="ngModel" [ngClass]="inputFieldCss(accountNumber, form)" minlength="16" required>
          <button class="btn btn-primary border-right" type="button" (click)="verifyTargetAccount(targetAccount.accountNumber)"><i class="fas fa-search"></i>&nbsp;{{ "accounts.transfers.validate" | translate }}</button>
        </div>
        <app-field-error-display [control]="accountNumber" [form]="form"></app-field-error-display>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label>{{ "accounts.transfers.name" | translate }}</label>
          <input type="text" class="form-control" name="alias" [(ngModel)]="targetAccount.alias" #alias="ngModel" [ngClass]="inputFieldCss(alias, form)" required>
          <app-field-error-display [control]="alias" [form]="form"></app-field-error-display>
        </div>
      </div>
    </div>

    <div class="mt-3" *ngIf="showAccountInfo">
      <p-card>
        <div class="d-flex flex-column justify-content-center align-items-center">
          <h5>{{ "accounts.transfers.account-info" | translate }}</h5>
          <hr style="border: 1px solid black; width: 100%;">
          <p><b>{{ "accounts.transfers.account-message" | translate }}</b></p>
          <p>{{ targetAccount.accountNumber | mask : '0000 0000 0000 0000'}}</p>
          <p><b>{{ "accounts.transfers.card-holder" | translate }}</b></p>
          <p>{{accountUserName}}</p>
        </div>
      </p-card>
    </div>

    <div class="row">
      <div class="col-12 text-right mt-3">
        <button *ngIf="mode === 'NEW'" [disabled]="!createTargetAccountBtn" type="submit" class="btn btn-primary">{{ "accounts.transfers.create" | translate }}</button>
        <button *ngIf="mode === 'EDIT'" type="submit" class="btn btn-primary">{{ "accounts.target_account.save" | translate }}</button>
        <button class="btn btn-secondary float-left" type="button" (click)="onBack(form)">{{ "accounts.target_account.back" | translate }}</button>
      </div>
    </div>
  </form>
</ng-template>

<!--Dialog to make look up-->
<p-dialog header=" " [(visible)]="verifyData" [modal]="true" [baseZIndex]="10000" style="padding: 0 !important;">
  <div class="d-flex flex-column align-items-center justify-content-center">
    <i class="fas fa-exclamation-circle fa-2x notification-circle-icon"></i>
    <p>{{ "accounts.transfers.notification-card" | translate }}</p>
    <p><b>{{ "accounts.transfers.notification-holder" | translate: {holder: accountUserName } }}</b></p>

  </div>
  <div class="d-flex justify-content-between">
    <button type="button" class="btn btn-outline-primary btn-yesno-width" (click)="verifyData = false">{{ "accounts.target_account.no" | translate}}</button>
    <button type="button" class="btn btn-outline-success ml-3 btn-yesno-width" (click)="confirmAccount();">{{ "accounts.target_account.yes" | translate}}</button>
  </div>
</p-dialog>

<!--Dialog to notify invalid code-->
<p-dialog header="{{ 'accounts.transfers.invalid-card-number-title' | translate }} " [(visible)]="displayInvalidAccount" [modal]="true" [baseZIndex]="10000">
  <div class="d-flex align-items-center justify-content-center flex-column">
    <p *ngIf="this.invalidCardNumberMessage">{{this.invalidCardNumberMessage}}</p>
    <p *ngIf="!this.invalidCardNumberMessage">{{ "accounts.transfers.invalid-card-number" | translate}}</p>
  </div>
  <div class="d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary btn-width"  (click)="displayInvalidAccount = false; invalidCardNumberMessage = null;">{{ "accounts.create_barcode.close" | translate}}</button>
  </div>
</p-dialog>

<p-dialog (onHide)="successConfirm()" header=" " [(visible)]="successPopup" [modal]="true" [baseZIndex]="10000" style="padding: 0 !important;">
  <div class="d-flex flex-column align-items-center justify-content-center">
    <i class="far fa-check-circle text-success top fa-2x"></i>
    <p *ngIf="mode === 'NEW'">{{ "accounts.target_account.added_success" | translate }}</p>
    <p *ngIf="mode === 'EDIT'">{{ "accounts.target_account.edited_success" | translate }}</p>
  </div>
  <hr>
  <div class="d-flex align-items-center justify-content-center w-100" (click)="successPopup = false" [style.cursor]="'pointer'">
    <p class="text-danger" >{{ "accounts.target_account.ok" | translate}}</p>
  </div>
</p-dialog>